/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { LogDto } from '../models/log-dto';
import { PageInfoDto } from '../models/page-info-dto';
import { RefundAccountResponseDto } from '../models/refund-account-response-dto';
import { userControllerAgreeTerms } from '../fn/user/user-controller-agree-terms';
import { UserControllerAgreeTerms$Params } from '../fn/user/user-controller-agree-terms';
import { userControllerBlock } from '../fn/user/user-controller-block';
import { UserControllerBlock$Params } from '../fn/user/user-controller-block';
import { userControllerCheckContact } from '../fn/user/user-controller-check-contact';
import { UserControllerCheckContact$Params } from '../fn/user/user-controller-check-contact';
import { userControllerCheckEmail } from '../fn/user/user-controller-check-email';
import { UserControllerCheckEmail$Params } from '../fn/user/user-controller-check-email';
import { userControllerCreate } from '../fn/user/user-controller-create';
import { UserControllerCreate$Params } from '../fn/user/user-controller-create';
import { userControllerCreateWithPhone } from '../fn/user/user-controller-create-with-phone';
import { UserControllerCreateWithPhone$Params } from '../fn/user/user-controller-create-with-phone';
import { userControllerDelete } from '../fn/user/user-controller-delete';
import { UserControllerDelete$Params } from '../fn/user/user-controller-delete';
import { userControllerExchange } from '../fn/user/user-controller-exchange';
import { UserControllerExchange$Params } from '../fn/user/user-controller-exchange';
import { userControllerFindAll } from '../fn/user/user-controller-find-all';
import { UserControllerFindAll$Params } from '../fn/user/user-controller-find-all';
import { userControllerFindById } from '../fn/user/user-controller-find-by-id';
import { UserControllerFindById$Params } from '../fn/user/user-controller-find-by-id';
import { userControllerFindEmail } from '../fn/user/user-controller-find-email';
import { UserControllerFindEmail$Params } from '../fn/user/user-controller-find-email';
import { userControllerFindLogs } from '../fn/user/user-controller-find-logs';
import { UserControllerFindLogs$Params } from '../fn/user/user-controller-find-logs';
import { userControllerGetDelivery } from '../fn/user/user-controller-get-delivery';
import { UserControllerGetDelivery$Params } from '../fn/user/user-controller-get-delivery';
import { userControllerGetMe } from '../fn/user/user-controller-get-me';
import { UserControllerGetMe$Params } from '../fn/user/user-controller-get-me';
import { userControllerGetNotificationSettings } from '../fn/user/user-controller-get-notification-settings';
import { UserControllerGetNotificationSettings$Params } from '../fn/user/user-controller-get-notification-settings';
import { userControllerGetRefundAccount } from '../fn/user/user-controller-get-refund-account';
import { UserControllerGetRefundAccount$Params } from '../fn/user/user-controller-get-refund-account';
import { userControllerGetRequireReAgreementTerms } from '../fn/user/user-controller-get-require-re-agreement-terms';
import { UserControllerGetRequireReAgreementTerms$Params } from '../fn/user/user-controller-get-require-re-agreement-terms';
import { userControllerLogin } from '../fn/user/user-controller-login';
import { UserControllerLogin$Params } from '../fn/user/user-controller-login';
import { userControllerLogout } from '../fn/user/user-controller-logout';
import { UserControllerLogout$Params } from '../fn/user/user-controller-logout';
import { userControllerPhoneLogin } from '../fn/user/user-controller-phone-login';
import { UserControllerPhoneLogin$Params } from '../fn/user/user-controller-phone-login';
import { userControllerRefresh } from '../fn/user/user-controller-refresh';
import { UserControllerRefresh$Params } from '../fn/user/user-controller-refresh';
import { userControllerRegisterRefundAccount } from '../fn/user/user-controller-register-refund-account';
import { UserControllerRegisterRefundAccount$Params } from '../fn/user/user-controller-register-refund-account';
import { userControllerResetPassword } from '../fn/user/user-controller-reset-password';
import { UserControllerResetPassword$Params } from '../fn/user/user-controller-reset-password';
import { userControllerResetPin } from '../fn/user/user-controller-reset-pin';
import { UserControllerResetPin$Params } from '../fn/user/user-controller-reset-pin';
import { userControllerSearchCursor } from '../fn/user/user-controller-search-cursor';
import { UserControllerSearchCursor$Params } from '../fn/user/user-controller-search-cursor';
import { userControllerSearchOffset } from '../fn/user/user-controller-search-offset';
import { UserControllerSearchOffset$Params } from '../fn/user/user-controller-search-offset';
import { userControllerSendCode } from '../fn/user/user-controller-send-code';
import { UserControllerSendCode$Params } from '../fn/user/user-controller-send-code';
import { userControllerSendEmailCode } from '../fn/user/user-controller-send-email-code';
import { UserControllerSendEmailCode$Params } from '../fn/user/user-controller-send-email-code';
import { userControllerSendPasswordResetEmail } from '../fn/user/user-controller-send-password-reset-email';
import { UserControllerSendPasswordResetEmail$Params } from '../fn/user/user-controller-send-password-reset-email';
import { userControllerUnblock } from '../fn/user/user-controller-unblock';
import { UserControllerUnblock$Params } from '../fn/user/user-controller-unblock';
import { userControllerUnwithdraw } from '../fn/user/user-controller-unwithdraw';
import { UserControllerUnwithdraw$Params } from '../fn/user/user-controller-unwithdraw';
import { userControllerUpdate } from '../fn/user/user-controller-update';
import { UserControllerUpdate$Params } from '../fn/user/user-controller-update';
import { userControllerUpdateBiometric } from '../fn/user/user-controller-update-biometric';
import { UserControllerUpdateBiometric$Params } from '../fn/user/user-controller-update-biometric';
import { userControllerUpdateContact } from '../fn/user/user-controller-update-contact';
import { UserControllerUpdateContact$Params } from '../fn/user/user-controller-update-contact';
import { userControllerUpdateDelivery } from '../fn/user/user-controller-update-delivery';
import { UserControllerUpdateDelivery$Params } from '../fn/user/user-controller-update-delivery';
import { userControllerUpdateNotificationSettings } from '../fn/user/user-controller-update-notification-settings';
import { UserControllerUpdateNotificationSettings$Params } from '../fn/user/user-controller-update-notification-settings';
import { userControllerUpdatePassword } from '../fn/user/user-controller-update-password';
import { UserControllerUpdatePassword$Params } from '../fn/user/user-controller-update-password';
import { userControllerUpdateRefundAccount } from '../fn/user/user-controller-update-refund-account';
import { UserControllerUpdateRefundAccount$Params } from '../fn/user/user-controller-update-refund-account';
import { userControllerVerifyCode } from '../fn/user/user-controller-verify-code';
import { UserControllerVerifyCode$Params } from '../fn/user/user-controller-verify-code';
import { userControllerVerifyEmailCode } from '../fn/user/user-controller-verify-email-code';
import { UserControllerVerifyEmailCode$Params } from '../fn/user/user-controller-verify-email-code';
import { userControllerVerifyPasswordResetCode } from '../fn/user/user-controller-verify-password-reset-code';
import { UserControllerVerifyPasswordResetCode$Params } from '../fn/user/user-controller-verify-password-reset-code';
import { userControllerWithdraw } from '../fn/user/user-controller-withdraw';
import { UserControllerWithdraw$Params } from '../fn/user/user-controller-withdraw';
import { UserDto } from '../models/user-dto';
import { UserEmailDto } from '../models/user-email-dto';
import { UserNotificationSettingsDto } from '../models/user-notification-settings-dto';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userControllerFindAll()` */
  static readonly UserControllerFindAllPath = '/api/user';

  /**
   * 사용자 전체 조회.
   *
   * 전체 사용자를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindAll$Response(params?: UserControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserDto>>> {
    const obs = userControllerFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 사용자 전체 조회.
   *
   * 전체 사용자를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindAll(params?: UserControllerFindAll$Params, context?: HttpContext): Observable<Array<UserDto>> {
    const resp = this.userControllerFindAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<UserDto>>): Array<UserDto> => r.body)
    );
  }

  /** Path part for operation `userControllerSearchOffset()` */
  static readonly UserControllerSearchOffsetPath = '/api/user/search/offset';

  /**
   * 사용자 오프셋 기반 조회.
   *
   * 사용자를 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerSearchOffset$Response(params: UserControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<UserDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = userControllerSearchOffset(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 사용자 오프셋 기반 조회.
   *
   * 사용자를 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerSearchOffset(params: UserControllerSearchOffset$Params, context?: HttpContext): Observable<{
'items': Array<UserDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.userControllerSearchOffset$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<UserDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<UserDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `userControllerSearchCursor()` */
  static readonly UserControllerSearchCursorPath = '/api/user/search/cursor';

  /**
   * 사용자 커서 기반 조회.
   *
   * 사용자를 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerSearchCursor$Response(params: UserControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<UserDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>> {
    const obs = userControllerSearchCursor(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 사용자 커서 기반 조회.
   *
   * 사용자를 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerSearchCursor(params: UserControllerSearchCursor$Params, context?: HttpContext): Observable<{
'items': Array<UserDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}> {
    const resp = this.userControllerSearchCursor$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<UserDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>): {
'items': Array<UserDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
} => r.body)
    );
  }

  /** Path part for operation `userControllerCheckEmail()` */
  static readonly UserControllerCheckEmailPath = '/api/user/check/email';

  /**
   * 이메일 중복 확인.
   *
   * 이메일 중복을 확인합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerCheckEmail()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerCheckEmail$Response(params: UserControllerCheckEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = userControllerCheckEmail(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 이메일 중복 확인.
   *
   * 이메일 중복을 확인합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerCheckEmail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerCheckEmail(params: UserControllerCheckEmail$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.userControllerCheckEmail$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `userControllerCheckContact()` */
  static readonly UserControllerCheckContactPath = '/api/user/check/contact';

  /**
   * 연락처 중복 확인.
   *
   * 연락처 중복을 확인합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerCheckContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerCheckContact$Response(params: UserControllerCheckContact$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = userControllerCheckContact(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 연락처 중복 확인.
   *
   * 연락처 중복을 확인합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerCheckContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerCheckContact(params: UserControllerCheckContact$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.userControllerCheckContact$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `userControllerGetMe()` */
  static readonly UserControllerGetMePath = '/api/user/me';

  /**
   * 내 정보 조회.
   *
   * 내 정보를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerGetMe()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetMe$Response(params?: UserControllerGetMe$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    const obs = userControllerGetMe(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 내 정보 조회.
   *
   * 내 정보를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerGetMe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetMe(params?: UserControllerGetMe$Params, context?: HttpContext): Observable<UserDto> {
    const resp = this.userControllerGetMe$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userControllerFindById()` */
  static readonly UserControllerFindByIdPath = '/api/user/{id}';

  /**
   * 사용자 ID 기반 조회.
   *
   * 사용자를 ID 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindById$Response(params: UserControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    const obs = userControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 사용자 ID 기반 조회.
   *
   * 사용자를 ID 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindById(params: UserControllerFindById$Params, context?: HttpContext): Observable<UserDto> {
    const resp = this.userControllerFindById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userControllerDelete()` */
  static readonly UserControllerDeletePath = '/api/user/{id}';

  /**
   * 사용자 삭제.
   *
   * 사용자를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerDelete$Response(params: UserControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    const obs = userControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 사용자 삭제.
   *
   * 사용자를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerDelete(params: UserControllerDelete$Params, context?: HttpContext): Observable<UserDto> {
    const resp = this.userControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userControllerUpdate()` */
  static readonly UserControllerUpdatePath = '/api/user/{id}';

  /**
   * 회원 정보 수정.
   *
   * 회원 정보를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdate$Response(params: UserControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    const obs = userControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 회원 정보 수정.
   *
   * 회원 정보를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdate(params: UserControllerUpdate$Params, context?: HttpContext): Observable<UserDto> {
    const resp = this.userControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userControllerFindLogs()` */
  static readonly UserControllerFindLogsPath = '/api/user/{id}/logs';

  /**
   * 사용자 로그 조회.
   *
   * 특정 사용자의 활동 로그를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerFindLogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindLogs$Response(params: UserControllerFindLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<LogDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = userControllerFindLogs(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 사용자 로그 조회.
   *
   * 특정 사용자의 활동 로그를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerFindLogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindLogs(params: UserControllerFindLogs$Params, context?: HttpContext): Observable<{
'items': Array<LogDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.userControllerFindLogs$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<LogDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<LogDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `userControllerFindEmail()` */
  static readonly UserControllerFindEmailPath = '/api/user/find/email';

  /**
   * 이메일 찾기.
   *
   * 사용자 연락처와 이름를 기반으로 해당 회원의 모든 이메일을 찾습니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerFindEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerFindEmail$Response(params: UserControllerFindEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserEmailDto>>> {
    const obs = userControllerFindEmail(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 이메일 찾기.
   *
   * 사용자 연락처와 이름를 기반으로 해당 회원의 모든 이메일을 찾습니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerFindEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerFindEmail(params: UserControllerFindEmail$Params, context?: HttpContext): Observable<Array<UserEmailDto>> {
    const resp = this.userControllerFindEmail$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<UserEmailDto>>): Array<UserEmailDto> => r.body)
    );
  }

  /** Path part for operation `userControllerSendPasswordResetEmail()` */
  static readonly UserControllerSendPasswordResetEmailPath = '/api/user/find/password';

  /**
   * 비밀번호 재설정 인증 코드 발송.
   *
   * 비밀번호 재설정을 위한 인증 코드를 이메일로 발송합니다. 소셜 로그인 계정은 비밀번호 재설정이 불가합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerSendPasswordResetEmail()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerSendPasswordResetEmail$Response(params: UserControllerSendPasswordResetEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'token'?: string;
}>> {
    const obs = userControllerSendPasswordResetEmail(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 비밀번호 재설정 인증 코드 발송.
   *
   * 비밀번호 재설정을 위한 인증 코드를 이메일로 발송합니다. 소셜 로그인 계정은 비밀번호 재설정이 불가합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerSendPasswordResetEmail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerSendPasswordResetEmail(params: UserControllerSendPasswordResetEmail$Params, context?: HttpContext): Observable<{
'token'?: string;
}> {
    const resp = this.userControllerSendPasswordResetEmail$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'token'?: string;
}>): {
'token'?: string;
} => r.body)
    );
  }

  /** Path part for operation `userControllerVerifyPasswordResetCode()` */
  static readonly UserControllerVerifyPasswordResetCodePath = '/api/user/find/password/verify';

  /**
   * 비밀번호 재설정 인증 코드 확인.
   *
   * 비밀번호 재설정을 위해 발송된 인증 코드를 확인하고, 비밀번호 재설정용 토큰을 반환합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerVerifyPasswordResetCode()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerVerifyPasswordResetCode$Response(params: UserControllerVerifyPasswordResetCode$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'resetToken'?: string;
}>> {
    const obs = userControllerVerifyPasswordResetCode(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 비밀번호 재설정 인증 코드 확인.
   *
   * 비밀번호 재설정을 위해 발송된 인증 코드를 확인하고, 비밀번호 재설정용 토큰을 반환합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerVerifyPasswordResetCode$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerVerifyPasswordResetCode(params: UserControllerVerifyPasswordResetCode$Params, context?: HttpContext): Observable<{
'resetToken'?: string;
}> {
    const resp = this.userControllerVerifyPasswordResetCode$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'resetToken'?: string;
}>): {
'resetToken'?: string;
} => r.body)
    );
  }

  /** Path part for operation `userControllerResetPassword()` */
  static readonly UserControllerResetPasswordPath = '/api/user/reset-password';

  /**
   * 비밀번호 재설정.
   *
   * 인증된 토큰을 사용하여 비밀번호를 재설정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerResetPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerResetPassword$Response(params: UserControllerResetPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = userControllerResetPassword(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 비밀번호 재설정.
   *
   * 인증된 토큰을 사용하여 비밀번호를 재설정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerResetPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerResetPassword(params: UserControllerResetPassword$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.userControllerResetPassword$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `userControllerLogin()` */
  static readonly UserControllerLoginPath = '/api/user/signin';

  /**
   * 사용자 로그인.
   *
   * 사용자로 로그인합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerLogin$Response(params: UserControllerLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'accessToken'?: string;
'refreshToken'?: string;
}>> {
    const obs = userControllerLogin(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 사용자 로그인.
   *
   * 사용자로 로그인합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerLogin(params: UserControllerLogin$Params, context?: HttpContext): Observable<{
'accessToken'?: string;
'refreshToken'?: string;
}> {
    const resp = this.userControllerLogin$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'accessToken'?: string;
'refreshToken'?: string;
}>): {
'accessToken'?: string;
'refreshToken'?: string;
} => r.body)
    );
  }

  /** Path part for operation `userControllerPhoneLogin()` */
  static readonly UserControllerPhoneLoginPath = '/api/user/signin/phone';

  /**
   * 휴대폰 번호 로그인.
   *
   * 휴대폰 번호와 PIN으로 로그인합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerPhoneLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerPhoneLogin$Response(params: UserControllerPhoneLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'accessToken'?: string;
'refreshToken'?: string;
'user'?: UserDto;
}>> {
    const obs = userControllerPhoneLogin(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 휴대폰 번호 로그인.
   *
   * 휴대폰 번호와 PIN으로 로그인합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerPhoneLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerPhoneLogin(params: UserControllerPhoneLogin$Params, context?: HttpContext): Observable<{
'accessToken'?: string;
'refreshToken'?: string;
'user'?: UserDto;
}> {
    const resp = this.userControllerPhoneLogin$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'accessToken'?: string;
'refreshToken'?: string;
'user'?: UserDto;
}>): {
'accessToken'?: string;
'refreshToken'?: string;
'user'?: UserDto;
} => r.body)
    );
  }

  /** Path part for operation `userControllerCreate()` */
  static readonly UserControllerCreatePath = '/api/user/signup';

  /**
   * 회원 가입.
   *
   * 회원으로 가입합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerCreate$Response(params: UserControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    const obs = userControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 회원 가입.
   *
   * 회원으로 가입합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerCreate(params: UserControllerCreate$Params, context?: HttpContext): Observable<UserDto> {
    const resp = this.userControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userControllerCreateWithPhone()` */
  static readonly UserControllerCreateWithPhonePath = '/api/user/signup/phone';

  /**
   * 휴대폰 번호 회원 가입.
   *
   * 휴대폰 번호와 PIN으로 회원으로 가입합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerCreateWithPhone()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerCreateWithPhone$Response(params: UserControllerCreateWithPhone$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    const obs = userControllerCreateWithPhone(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 휴대폰 번호 회원 가입.
   *
   * 휴대폰 번호와 PIN으로 회원으로 가입합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerCreateWithPhone$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerCreateWithPhone(params: UserControllerCreateWithPhone$Params, context?: HttpContext): Observable<UserDto> {
    const resp = this.userControllerCreateWithPhone$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userControllerSendEmailCode()` */
  static readonly UserControllerSendEmailCodePath = '/api/user/email/code';

  /**
   * 이메일 인증 코드 발송.
   *
   * 이메일로 인증 코드를 발송합니다. 발송된 코드를 확인하는 토큰을 반환합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerSendEmailCode()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerSendEmailCode$Response(params: UserControllerSendEmailCode$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'token'?: string;
}>> {
    const obs = userControllerSendEmailCode(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 이메일 인증 코드 발송.
   *
   * 이메일로 인증 코드를 발송합니다. 발송된 코드를 확인하는 토큰을 반환합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerSendEmailCode$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerSendEmailCode(params: UserControllerSendEmailCode$Params, context?: HttpContext): Observable<{
'token'?: string;
}> {
    const resp = this.userControllerSendEmailCode$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'token'?: string;
}>): {
'token'?: string;
} => r.body)
    );
  }

  /** Path part for operation `userControllerVerifyEmailCode()` */
  static readonly UserControllerVerifyEmailCodePath = '/api/user/email/verify';

  /**
   * 이메일 인증 코드 확인.
   *
   * 이메일로 발송된 인증 코드를 확인합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerVerifyEmailCode()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerVerifyEmailCode$Response(params: UserControllerVerifyEmailCode$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = userControllerVerifyEmailCode(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 이메일 인증 코드 확인.
   *
   * 이메일로 발송된 인증 코드를 확인합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerVerifyEmailCode$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerVerifyEmailCode(params: UserControllerVerifyEmailCode$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.userControllerVerifyEmailCode$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `userControllerRefresh()` */
  static readonly UserControllerRefreshPath = '/api/user/refresh';

  /**
   * 엑세스 토큰 갱신.
   *
   * 엑세스 토큰을 갱신합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerRefresh()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerRefresh$Response(params: UserControllerRefresh$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'accessToken'?: string;
}>> {
    const obs = userControllerRefresh(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 엑세스 토큰 갱신.
   *
   * 엑세스 토큰을 갱신합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerRefresh$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerRefresh(params: UserControllerRefresh$Params, context?: HttpContext): Observable<{
'accessToken'?: string;
}> {
    const resp = this.userControllerRefresh$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'accessToken'?: string;
}>): {
'accessToken'?: string;
} => r.body)
    );
  }

  /** Path part for operation `userControllerLogout()` */
  static readonly UserControllerLogoutPath = '/api/user/signout';

  /**
   * 로그아웃.
   *
   * 로그아웃합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerLogout()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerLogout$Response(params?: UserControllerLogout$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = userControllerLogout(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 로그아웃.
   *
   * 로그아웃합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerLogout$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerLogout(params?: UserControllerLogout$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.userControllerLogout$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `userControllerSendCode()` */
  static readonly UserControllerSendCodePath = '/api/user/code';

  /**
   * 연락처 인증 코드 발송.
   *
   * 연락처로 인증을 요청합니다. 이름과 함께 요청하는 경우, 계정과 이름이 일치하는지 확인합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerSendCode()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerSendCode$Response(params: UserControllerSendCode$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'token'?: string;
}>> {
    const obs = userControllerSendCode(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 연락처 인증 코드 발송.
   *
   * 연락처로 인증을 요청합니다. 이름과 함께 요청하는 경우, 계정과 이름이 일치하는지 확인합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerSendCode$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerSendCode(params: UserControllerSendCode$Params, context?: HttpContext): Observable<{
'token'?: string;
}> {
    const resp = this.userControllerSendCode$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'token'?: string;
}>): {
'token'?: string;
} => r.body)
    );
  }

  /** Path part for operation `userControllerVerifyCode()` */
  static readonly UserControllerVerifyCodePath = '/api/user/code/verify';

  /**
   * 연락처 인증 코드 확인.
   *
   * 연락처로 전송된 인증 코드를 확인합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerVerifyCode()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerVerifyCode$Response(params: UserControllerVerifyCode$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = userControllerVerifyCode(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 연락처 인증 코드 확인.
   *
   * 연락처로 전송된 인증 코드를 확인합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerVerifyCode$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerVerifyCode(params: UserControllerVerifyCode$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.userControllerVerifyCode$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `userControllerResetPin()` */
  static readonly UserControllerResetPinPath = '/api/user/reset-pin';

  /**
   * PIN 번호 재설정.
   *
   * 휴대폰 인증 후 PIN 번호를 재설정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerResetPin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerResetPin$Response(params: UserControllerResetPin$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = userControllerResetPin(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * PIN 번호 재설정.
   *
   * 휴대폰 인증 후 PIN 번호를 재설정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerResetPin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerResetPin(params: UserControllerResetPin$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.userControllerResetPin$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `userControllerUpdateBiometric()` */
  static readonly UserControllerUpdateBiometricPath = '/api/user/biometric';

  /**
   * 바이오 인증 설정 업데이트.
   *
   * 사용자의 바이오 인증 활성화 여부를 업데이트합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerUpdateBiometric()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdateBiometric$Response(params: UserControllerUpdateBiometric$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    const obs = userControllerUpdateBiometric(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 바이오 인증 설정 업데이트.
   *
   * 사용자의 바이오 인증 활성화 여부를 업데이트합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerUpdateBiometric$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdateBiometric(params: UserControllerUpdateBiometric$Params, context?: HttpContext): Observable<UserDto> {
    const resp = this.userControllerUpdateBiometric$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userControllerGetRefundAccount()` */
  static readonly UserControllerGetRefundAccountPath = '/api/user/me/refund-account';

  /**
   * 환불계좌 조회.
   *
   * 현재 로그인한 사용자의 환불계좌 정보를 조회합니다. 계좌번호는 마스킹 처리됩니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerGetRefundAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetRefundAccount$Response(params?: UserControllerGetRefundAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<RefundAccountResponseDto>> {
    const obs = userControllerGetRefundAccount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 환불계좌 조회.
   *
   * 현재 로그인한 사용자의 환불계좌 정보를 조회합니다. 계좌번호는 마스킹 처리됩니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerGetRefundAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetRefundAccount(params?: UserControllerGetRefundAccount$Params, context?: HttpContext): Observable<RefundAccountResponseDto> {
    const resp = this.userControllerGetRefundAccount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RefundAccountResponseDto>): RefundAccountResponseDto => r.body)
    );
  }

  /** Path part for operation `userControllerRegisterRefundAccount()` */
  static readonly UserControllerRegisterRefundAccountPath = '/api/user/me/refund-account';

  /**
   * 환불계좌 등록.
   *
   * 환불계좌를 등록합니다. PIN 인증이 필요합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerRegisterRefundAccount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerRegisterRefundAccount$Response(params: UserControllerRegisterRefundAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<RefundAccountResponseDto>> {
    const obs = userControllerRegisterRefundAccount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 환불계좌 등록.
   *
   * 환불계좌를 등록합니다. PIN 인증이 필요합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerRegisterRefundAccount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerRegisterRefundAccount(params: UserControllerRegisterRefundAccount$Params, context?: HttpContext): Observable<RefundAccountResponseDto> {
    const resp = this.userControllerRegisterRefundAccount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RefundAccountResponseDto>): RefundAccountResponseDto => r.body)
    );
  }

  /** Path part for operation `userControllerUpdateRefundAccount()` */
  static readonly UserControllerUpdateRefundAccountPath = '/api/user/me/refund-account';

  /**
   * 환불계좌 변경.
   *
   * 환불계좌를 변경합니다. PIN 인증이 필요합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerUpdateRefundAccount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdateRefundAccount$Response(params: UserControllerUpdateRefundAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<RefundAccountResponseDto>> {
    const obs = userControllerUpdateRefundAccount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 환불계좌 변경.
   *
   * 환불계좌를 변경합니다. PIN 인증이 필요합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerUpdateRefundAccount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdateRefundAccount(params: UserControllerUpdateRefundAccount$Params, context?: HttpContext): Observable<RefundAccountResponseDto> {
    const resp = this.userControllerUpdateRefundAccount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RefundAccountResponseDto>): RefundAccountResponseDto => r.body)
    );
  }

  /** Path part for operation `userControllerGetDelivery()` */
  static readonly UserControllerGetDeliveryPath = '/api/user/me/delivery';

  /**
   * 배송지 조회.
   *
   * 저장된 기본 배송지를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerGetDelivery()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetDelivery$Response(params?: UserControllerGetDelivery$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
    const obs = userControllerGetDelivery(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배송지 조회.
   *
   * 저장된 기본 배송지를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerGetDelivery$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetDelivery(params?: UserControllerGetDelivery$Params, context?: HttpContext): Observable<{
}> {
    const resp = this.userControllerGetDelivery$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `userControllerUpdateDelivery()` */
  static readonly UserControllerUpdateDeliveryPath = '/api/user/me/delivery';

  /**
   * 배송지 저장/수정.
   *
   * 기본 배송지를 저장하거나 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerUpdateDelivery()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdateDelivery$Response(params: UserControllerUpdateDelivery$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
    const obs = userControllerUpdateDelivery(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배송지 저장/수정.
   *
   * 기본 배송지를 저장하거나 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerUpdateDelivery$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdateDelivery(params: UserControllerUpdateDelivery$Params, context?: HttpContext): Observable<{
}> {
    const resp = this.userControllerUpdateDelivery$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `userControllerExchange()` */
  static readonly UserControllerExchangePath = '/api/user/oauth/exchange';

  /**
   * OAuth 토큰 교환.
   *
   * OAuth 인증 후 발급된 교환 토큰을 엑세스 토큰과 리프레시 토큰으로 교환합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerExchange()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerExchange$Response(params: UserControllerExchange$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'accessToken'?: string;
'refreshToken'?: string;
}>> {
    const obs = userControllerExchange(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * OAuth 토큰 교환.
   *
   * OAuth 인증 후 발급된 교환 토큰을 엑세스 토큰과 리프레시 토큰으로 교환합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerExchange$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerExchange(params: UserControllerExchange$Params, context?: HttpContext): Observable<{
'accessToken'?: string;
'refreshToken'?: string;
}> {
    const resp = this.userControllerExchange$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'accessToken'?: string;
'refreshToken'?: string;
}>): {
'accessToken'?: string;
'refreshToken'?: string;
} => r.body)
    );
  }

  /** Path part for operation `userControllerUpdatePassword()` */
  static readonly UserControllerUpdatePasswordPath = '/api/user/password';

  /**
   * 비밀번호 변경.
   *
   * 비밀번호를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerUpdatePassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdatePassword$Response(params: UserControllerUpdatePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = userControllerUpdatePassword(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 비밀번호 변경.
   *
   * 비밀번호를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerUpdatePassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdatePassword(params: UserControllerUpdatePassword$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.userControllerUpdatePassword$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `userControllerUpdateContact()` */
  static readonly UserControllerUpdateContactPath = '/api/user/contact';

  /**
   * 연락처 변경.
   *
   * 연락처를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerUpdateContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdateContact$Response(params: UserControllerUpdateContact$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = userControllerUpdateContact(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 연락처 변경.
   *
   * 연락처를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerUpdateContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdateContact(params: UserControllerUpdateContact$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.userControllerUpdateContact$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `userControllerWithdraw()` */
  static readonly UserControllerWithdrawPath = '/api/user/withdraw';

  /**
   * 회원 탈퇴.
   *
   * 회원을 탈퇴 대기 상태(재가입 가능)로 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerWithdraw()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerWithdraw$Response(params: UserControllerWithdraw$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = userControllerWithdraw(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 회원 탈퇴.
   *
   * 회원을 탈퇴 대기 상태(재가입 가능)로 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerWithdraw$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerWithdraw(params: UserControllerWithdraw$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.userControllerWithdraw$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `userControllerUnwithdraw()` */
  static readonly UserControllerUnwithdrawPath = '/api/user/unwithdraw';

  /**
   * 회원 탈퇴 취소.
   *
   * 회원 탈퇴를 취소합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerUnwithdraw()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerUnwithdraw$Response(params?: UserControllerUnwithdraw$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = userControllerUnwithdraw(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 회원 탈퇴 취소.
   *
   * 회원 탈퇴를 취소합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerUnwithdraw$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerUnwithdraw(params?: UserControllerUnwithdraw$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.userControllerUnwithdraw$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `userControllerBlock()` */
  static readonly UserControllerBlockPath = '/api/user/{id}/block';

  /**
   * 사용자 차단.
   *
   * 사용자를 차단합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerBlock()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerBlock$Response(params: UserControllerBlock$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = userControllerBlock(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 사용자 차단.
   *
   * 사용자를 차단합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerBlock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerBlock(params: UserControllerBlock$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.userControllerBlock$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `userControllerUnblock()` */
  static readonly UserControllerUnblockPath = '/api/user/{id}/unblock';

  /**
   * 사용자 차단 해제.
   *
   * 사용자의 차단을 해제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerUnblock()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerUnblock$Response(params: UserControllerUnblock$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = userControllerUnblock(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 사용자 차단 해제.
   *
   * 사용자의 차단을 해제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerUnblock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerUnblock(params: UserControllerUnblock$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.userControllerUnblock$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `userControllerGetNotificationSettings()` */
  static readonly UserControllerGetNotificationSettingsPath = '/api/user/me/notification-settings';

  /**
   * 알림 설정 조회.
   *
   * 현재 로그인한 사용자의 알림 설정을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerGetNotificationSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetNotificationSettings$Response(params?: UserControllerGetNotificationSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<UserNotificationSettingsDto>> {
    const obs = userControllerGetNotificationSettings(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 알림 설정 조회.
   *
   * 현재 로그인한 사용자의 알림 설정을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerGetNotificationSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetNotificationSettings(params?: UserControllerGetNotificationSettings$Params, context?: HttpContext): Observable<UserNotificationSettingsDto> {
    const resp = this.userControllerGetNotificationSettings$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserNotificationSettingsDto>): UserNotificationSettingsDto => r.body)
    );
  }

  /** Path part for operation `userControllerUpdateNotificationSettings()` */
  static readonly UserControllerUpdateNotificationSettingsPath = '/api/user/me/notification-settings';

  /**
   * 알림 설정 업데이트.
   *
   * 현재 로그인한 사용자의 알림 설정을 업데이트합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerUpdateNotificationSettings()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdateNotificationSettings$Response(params: UserControllerUpdateNotificationSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<UserNotificationSettingsDto>> {
    const obs = userControllerUpdateNotificationSettings(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 알림 설정 업데이트.
   *
   * 현재 로그인한 사용자의 알림 설정을 업데이트합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerUpdateNotificationSettings$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdateNotificationSettings(params: UserControllerUpdateNotificationSettings$Params, context?: HttpContext): Observable<UserNotificationSettingsDto> {
    const resp = this.userControllerUpdateNotificationSettings$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserNotificationSettingsDto>): UserNotificationSettingsDto => r.body)
    );
  }

  /** Path part for operation `userControllerGetRequireReAgreementTerms()` */
  static readonly UserControllerGetRequireReAgreementTermsPath = '/api/user/terms/require-re-agreement';

  /**
   * 재동의 필요 약관 조회.
   *
   * 현재 사용자가 재동의해야 하는 약관 목록을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerGetRequireReAgreementTerms()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetRequireReAgreementTerms$Response(params?: UserControllerGetRequireReAgreementTerms$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<{
}>>> {
    const obs = userControllerGetRequireReAgreementTerms(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 재동의 필요 약관 조회.
   *
   * 현재 사용자가 재동의해야 하는 약관 목록을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerGetRequireReAgreementTerms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetRequireReAgreementTerms(params?: UserControllerGetRequireReAgreementTerms$Params, context?: HttpContext): Observable<Array<{
}>> {
    const resp = this.userControllerGetRequireReAgreementTerms$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<{
}>>): Array<{
}> => r.body)
    );
  }

  /** Path part for operation `userControllerAgreeTerms()` */
  static readonly UserControllerAgreeTermsPath = '/api/user/terms/agree';

  /**
   * 약관 동의 처리.
   *
   * 사용자가 변경된 약관에 동의합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerAgreeTerms()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerAgreeTerms$Response(params?: UserControllerAgreeTerms$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = userControllerAgreeTerms(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 약관 동의 처리.
   *
   * 사용자가 변경된 약관에 동의합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerAgreeTerms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerAgreeTerms(params?: UserControllerAgreeTerms$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.userControllerAgreeTerms$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
